(() => {
  if (customElements.get('product-notify-popup')) return;
  customElements.define('product-notify-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-product-notify-open]');
        if (!trigger || this.dialog.open) return;
        event.preventDefault();
        this.trigger = trigger;
        this.dialog.showModal();
        this.dialog.focus({ preventScroll: true });
        document.documentElement.classList.add('product-notify-open');
      }, options);
      this.querySelector('[data-notify-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      // Keep Shopify's app block mounted: it owns validation, submission and success.
      this.closest('.shopify-section')?.addEventListener('shopify:section:select', () => {
        if (!this.dialog.open) this.dialog.showModal();
      }, options);
      this.closest('.shopify-section')?.addEventListener('shopify:section:deselect', () => this.dialog.close(), options);
    }
    restore() {
      document.documentElement.classList.remove('product-notify-open');
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.restore();
    }
  });
})();
